// Single source of truth for the business's name/address/phone (NAP) and
// related facts used across page <title>/meta tags and JSON-LD schema.
// Keep this in sync with what's actually printed on the Contact page -
// structured data must match visible content.

const business = {
  siteUrl: "https://azmrehabcentre.pk",
  name: "Azm Rehab Centre",
  legalName: "Azm Rehabilitation Centre",
  description:
    "Azm Rehab Centre is a trusted drug addiction and psychological treatment center in Sargodha, Punjab, offering rehabilitation and recovery services for ice, heroin, alcohol, opium, hashish, cocaine and sedative addiction.",
  telephone: "+923009605574",
  telephoneDisplay: "0300-9605574",
  email: "zubairmukhtar14@gmail.com",
  logo: "https://res.cloudinary.com/dll4d2yu7/image/upload/v1715876975/logo-azm-2_gvoves.png",
  address: {
    streetAddress: "329/A Punjab College Road, Satellite Town",
    addressLocality: "Sargodha",
    addressRegion: "Punjab",
    postalCode: "40100",
    addressCountry: "PK",
  },
  addressDisplay:
    "329/A Punjab College Road, Satellite Town, Sargodha, Punjab 40100",
  geo: {
    latitude: 32.0791,
    longitude: 72.6711,
  },
  // Mirrors the default schedule seeded in the backend (OpeningHourSeeder) -
  // the live Opening Hours widgets on the site call the API for the real
  // current schedule; this is only the static fallback used in schema.org
  // markup for search engines.
  openingHours: [
    {
      dayOfWeek: [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ],
      opens: "09:00",
      closes: "22:00",
    },
  ],
};

export default business;
